<template>
  <div class="document-uploader">
    <label :for="inputId" class="upload-button" :class="{ uploading }">
      <i class="el-icon-upload"></i>
      <span>{{ uploading ? 'Uploading…' : label }}</span>
    </label>
    <input
      :id="inputId"
      type="file"
      accept=".pdf,application/pdf,image/*"
      class="hidden-file"
      @change="onChange" />
    <div v-if="errorMessage" class="error">{{ errorMessage }}</div>
  </div>
</template>

<script>
export default {
  name: 'DocumentUploader',
  props: {
    label: {
      type: String,
      required: false,
      default: 'Upload PDF'
    }
  },
  data () {
    return {
      uploading: false,
      errorMessage: null,
      inputId: 'doc-upload-' + this._uid
    }
  },
  methods: {
    async onChange (event) {
      const file = event.target.files && event.target.files[0]
      if (!file) return
      this.errorMessage = null
      this.uploading = true
      this.$emit('uploadStart')
      try {
        const data = new FormData()
        data.append('file', file)
        const response = await this.$http.post(this.$api.files, data)
        this.$emit('input', response.data.id)
        this.$emit('uploadSuccess', response.data)
      } catch (e) {
        this.errorMessage = 'Could not upload file — try again.'
        this.$emit('uploadError', e)
      } finally {
        this.uploading = false
        event.target.value = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .document-uploader {
    display: flex;
    flex-direction: column;
  }

  .upload-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 12px 20px;
    border: 1px dashed #c0c4cc;
    border-radius: 4px;
    cursor: pointer;
    color: #606266;
    font-size: 13px;
    background-color: #fafafa;
    transition: border-color 0.2s, color 0.2s, background-color 0.2s;

    i {
      font-size: 18px;
      margin-right: 8px;
      color: #008fcc;
    }

    &:hover {
      border-color: #008fcc;
      color: #008fcc;
      background-color: #f4f8fb;
    }

    &.uploading {
      cursor: progress;
      opacity: 0.7;
    }
  }

  .hidden-file {
    display: none;
  }

  .error {
    margin-top: 6px;
    color: #f56c6c;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/stations/station/Certification/DocumentUploader.vue